// extracted by mini-css-extract-plugin
export default {"mobileTabs":"styles_mobileTabs__UANvo","layoutSlider":"styles_layoutSlider__K+fOW"};